import type { AxiosRequestConfig } from 'axios';
import { api } from '../../axios.instance';
import { responseContract, transformOptionalString } from '../../lib';
import {
  MarketFacilityFormResponseDtoSchema,
  UpdateMarketFacilityFormRequestDtoSchema,
  type MarketFacilityFormResponseDto,
  type UpdateMarketFacilityFormRequestDto,
} from '../contracts';

export type UpdateMarketFacilityFormResponseDto = MarketFacilityFormResponseDto;

export const updateMarketFacilityForm = (
  formId: number,
  dto: UpdateMarketFacilityFormRequestDto,
  config?: AxiosRequestConfig<UpdateMarketFacilityFormRequestDto>
) => {
  const transformedDto = {
    ...dto,
    administrator: transformOptionalString(dto.administrator),
    admissionsContact: transformOptionalString(dto.admissionsContact),
    marketingContact: transformOptionalString(dto.marketingContact),
    notes: transformOptionalString(dto.notes),
    ownerName: transformOptionalString(dto.ownerName),
    website: transformOptionalString(dto.website),
  };

  const data = UpdateMarketFacilityFormRequestDtoSchema.parse(transformedDto);
  return api
    .put(`/market-facilities/form/${formId}`, data, config)
    .then(responseContract(MarketFacilityFormResponseDtoSchema));
};
